<!--通用规范样式-->
<template>
    <div class="standardPage">
        <!-- <div class="box c-button">
            <h5>按钮部分</h5>
            <div>
                <el-button type="primary" class="c-btn">默认按钮</el-button>
                <el-button type="primary" class="c-btn" :disabled="true">不可点击</el-button>
                <el-button class="c-btn">默认按钮</el-button>
                <el-button class="c-btn" :disabled="true">不可点击</el-button>
            </div>
            <div>
                <el-button type="danger" class="c-btn">危险按钮</el-button>
                <el-button type="danger" class="c-btn" :disabled="true">危险按钮</el-button>
                <el-button type="danger" class="c-btn" plain>危险按钮</el-button>
                <el-button type="danger" class="c-btn" plain :disabled="true">危险按钮</el-button>
            </div>
            <div>
                <el-button type="warning" class="c-btn">警告按钮</el-button>
                <el-button type="warning" class="c-btn" :disabled="true">警告按钮</el-button>
                <el-button type="warning" class="c-btn" plain>警告按钮</el-button>
                <el-button type="warning" class="c-btn" plain :disabled="true">警告按钮</el-button>
            </div>
            <div>
                <el-button type="info" class="c-btn">信息按钮</el-button>
                <el-button type="info" class="c-btn" :disabled="true">信息按钮</el-button>
                <el-button type="info" class="c-btn" plain>信息按钮</el-button>
                <el-button type="info" class="c-btn" plain :disabled="true">信息按钮</el-button>
            </div>
            <div>
                <el-button type="info" class="c-btn lager">大型按钮</el-button>
                <el-button type="warning" class="c-btn small">小型按钮</el-button>
                <el-button type="danger" class="c-btn mini">超小按钮</el-button>
            </div>
            <div>
                <el-button type="primary" icon="el-icon-edit" class="c-btn c-icon"></el-button>
                <el-button icon="el-icon-edit" class="c-btn c-icon" plain></el-button>
                <el-button type="primary" icon="el-icon-share" class="c-btn c-icon"></el-button>
                <el-button type="primary" icon="el-icon-delete" class="c-btn c-icon"></el-button>
                <el-button type="primary" icon="el-icon-search" class="c-btn">搜索</el-button>
                <el-button type="primary" class="c-btn">上传<i class="el-icon-upload el-icon--right"></i></el-button>
            </div>
            <div>
                <el-button type="primary" class="c-btn btn-block">块级按钮</el-button>
            </div>
            <div>
                <el-button class="c-btn btn-block btn-dash">块级按钮 虚线边框按钮</el-button>
            </div>
        </div> -->
        <!-- <div class="box form">
            <h5>form表单</h5>
            <div>
                <el-input placeholder="请输入内容" v-model="input3" class="c-form" clearable>
                    <template slot="prepend">Http://</template>
                </el-input>
            </div>
            <div>
                <el-input placeholder="请输入内容" v-model="input4" class="c-form" clearable>
                    <template slot="append">.com</template>
                </el-input>
            </div>
            <div>
                <el-input placeholder="请输入内容" v-model="input5" class="c-form" clearable>
                    <el-select v-model="select" style="width: 130px;" slot="prepend" placeholder="请选择">
                        <el-option label="餐厅名" value="1"></el-option>
                        <el-option label="订单号" value="2"></el-option>
                        <el-option label="用户电话" value="3"></el-option>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search"></el-button>
                </el-input>
            </div>
            <div>
                <el-input
                        placeholder="请输入内容"
                        v-model="input5"
                        class="c-form"
                        clearable>
                </el-input>
            </div>
        </div> -->
        <div class="box form icon-box">
            <h5>icon svg图标</h5>
            <div>
                <textarea id="copyHelper">这是幕后黑手</textarea>
                <el-row>
                    <el-col :span="8" v-for="(item,index) in iconList" :key="index">
                        <i class="iconfont" :class="item.className"></i>
                        <span class="name" v-text="item.className"></span>
                        <el-button type="primary" class="c-btn mini" @click="copy(item.className)">复制</el-button>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "standardPage",
        data() {
            return {
                input3: '',
                input4: '',
                input5: '',
                select: '',
                iconList: [
                    {className: 'icon-fillinformation_dropdown', content: "\e646" },
                    {className: 'icon-nav_arrow', content: "\e647"},
                    {className: 'icon-lishijilu', content: "\e648"},
                    {className: 'icon-nav_commodity', content: "\e649"},
                    {className: 'icon-mianbaoxie-fanhui', content: "\e64a"},
                    {className: 'icon-gengduocaozuo', content: "\e64b"},
                    {className: 'icon-search', content: "\e64c"},
                    {className: 'icon-selected', content: "\e64d"},
                    {className: 'icon-top_back', content: "\e64e"},
                    {className: 'icon-timepicker', content: "\e64f"},
                    {className: 'icon-top_fold', content: "\e650"},
                    {className: 'icon-top_park', content: "\e651"},
                    {className: 'icon-top_messege', content: "\e652"},
                    {className: 'icon-reset', content: "\e653"},
                    {className: 'icon-unchecked', content: "\e654"},
                    {className: 'icon-nav_set', content: "\e655"},
                    {className: 'icon-choosingpark_check_n', content: "\e656"},
                    {className: 'icon-choosingpark_previouspage_s', content: "\e657"},
                    {className: 'icon-choosingpark_previouspage_n', content: "\e658"},
                    {className: 'icon-fillinformation_close', content: "\e659"},
                    {className: 'icon-fillinformation_legalperson', content: "\e65a"},
                    {className: 'icon-fillinformatio_bank', content: "\e65b"},
                    {className: 'icon-fillinformation_enterpriseInformation', content: "\e65c"},
                    {className: 'icon-fillinformation_shopinfo', content: "\e65d"},
                    {className: 'icon-login_account', content: "\e65e"},
                    {className: 'icon-fillinformation_add', content: "\e65f"},
                    {className: 'icon-choosingpark_check_s', content: "\e660"},
                    {className: 'icon-fillinformation_upload', content: "\e661"},
                    {className: 'icon-speedofprogress_close', content: "\e662"},
                    {className: 'icon-login_password', content: "\e663"},
                    {className: 'icon-speedofprogress_hook', content: "\e664"},
                    {className: 'icon-bukejian', content: "\e665"},
                    {className: 'icon-kejian', content: "\e666"},
                    {className: 'icon-choosingpark_check_n1', content: "\e617"},
                ]
            }
        },
        methods: {
            copy(text) {
                try {
                    const Url2=document.getElementById('copyHelper');
                    Url2.value = text
                    Url2.select(); // 选择对象
                    document.execCommand("Copy"); // 执行浏览器复制命令
                    this.$message({
                        message: '复制成功！',
                        type: 'success'
                    });
                } catch (e) {
                    this.$message({
                        message: '复制失败！',
                        type: 'error'
                    });
                }
            }
        },
    }
</script>

<style lang="scss">
    .standardPage {
        width: 1200px;
        margin: 0 auto;
        .box{
            background-color: white;
            padding: 20px;
            margin-bottom: 30px;
            h5{
                margin-bottom: 20px;
            }
            &.c-button{
                div{
                    margin-bottom: 10px;
                }
            }
            &.form{
                >div{
                    margin-bottom: 15px;
                }
            }
        }
        .icon-box {
            #copyHelper {
                visibility: hidden;
            }
            .el-col {
                i {
                    font-size: 18px;
                    margin-right: 10px;
                    display: inline-block;
                    width: 25px;
                }
                padding: 10px 20px;
                .el-button {
                    float: right;
                }
            }
        }
    }
</style>
